import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
import { tv } from 'tailwind-variants';
import type { VariantProps } from 'tailwind-variants';
const loadingDots = tv({
  base: 'rounded-full bg-slate-400 animate-dot-pulse',
  variants: {
    variant: {
      light: 'bg-content-inverse-primary',
      dark: 'bg-content-primary'
    },
    size: {
      sm: 'size-0.5',
      md: 'size-1',
      lg: 'size-2'
    }
  },
  defaultVariants: {
    size: 'md',
    variant: 'light'
  }
});
export function LoadingDots(t0) {
  const $ = _c(9);
  const {
    className,
    size,
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Array.from({
      length: 4
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const dots = t1;
  let t2;
  if ($[1] !== className) {
    t2 = twMerge("flex items-center gap-1", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== size || $[4] !== variant) {
    t3 = dots.map((_, index) => <div className={loadingDots({
      size,
      variant
    })} key={index} style={{
      animationDelay: `${index * 0.3}s`
    }} />);
    $[3] = size;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}